class ArticlesController {
    init() {

    }

    index() {
        // Table sorting and pagination now handled by Stimulus table controller
    }

    edit() {

    }

    blog() {
        let mySwiper = new window.Swiper(".swiper-container", {
            keyboard: true,
            centeredSlides: true,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next.blog-mobile',
                prevEl: '.swiper-button-prev.blog-mobile'
            }
        });
    }
}

// Set up BC namespace and register controller
window.BC = window.BC || {};
window.BC.articles = new ArticlesController();